import styles from './index.module.scss';

const Container = ({
  children,
  id,
  dataId,
}: {
  children: React.ReactNode;
  id?: string;
  dataId?: string;
}) => {
  return (
    <div className={styles.container} data-id={dataId} id={id}>
      {children}
    </div>
  );
};

export default Container;
